<div class="dialog-content-max">
    <form [formGroup]="LocationForm">
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="locationname" class="required-label">Location Name<span class="maxchars">(Max 100 chars)</span><span>*</span></label>
                <input type="text" class="form-control" id="locationname" inputId="locationname"
                    placeholder="Enter Location Name" name="locationname" formControlName="locationname" required>
                <span class="errormessage"
                    *ngIf="LocationForm.get('locationname').invalid && (LocationForm.get('locationname').touched || LocationForm.get('locationname').dirty) ">
                    {{getErrorMessage(LocationForm ,validation_message,'locationname')}}
                </span>
            </div>

        </div>
        <div class="formgrid grid">
            <div class="field col-6">
                <label for="countryid" class="required-label">Country<span>*</span></label> 
                <p-dropdown [resetFilterOnHide]="true" [options]="countyList" [filter]="true" appendTo="body"
                    optionLabel="countryname" optionValue="countryid" [showClear]="true" formControlName="countryid"
                    [readonly]="onlyView" (onChange)="getState(LocationForm.get('countryid').value)" inputId="countryid"
                    name="countryid"></p-dropdown>
                <span class="errormessage"
                    *ngIf="LocationForm.get('countryid').invalid  && (LocationForm.get('countryid').touched || LocationForm.get('countryid').dirty)">
                    {{getErrorMessage(LocationForm,validation_message,'countryid')}}
                </span>
            </div>
            <div class="field col-6">
                <label for="stateid" class="required-label">State<span>*</span></label>  
                <p-dropdown [resetFilterOnHide]="true" [showClear]="true" [options]="stateList" [filter]="true"
                    appendTo="body" optionLabel="statename" optionValue="stateid" placeholder="Select State"
                    formControlName="stateid" [readonly]="onlyView" inputId="stateid" name="stateid"></p-dropdown>
                <span class="errormessage"
                    *ngIf="LocationForm.get('stateid').invalid  && (LocationForm.get('stateid').touched || LocationForm.get('stateid').dirty)">
                    {{getErrorMessage(LocationForm,validation_message,'stateid')}}
                </span>
            </div>

        </div>
        <div class="formgrid grid">
            <div *ngIf="this.isHubEnabled == 'Y'" class="field col-6">
                <label for="hubid" class="required-label">Hub<span>*</span></label>   
                <p-dropdown [resetFilterOnHide]="true" [showClear]="true" [options]="hubList" [filter]="true"
                    appendTo="body" optionLabel="hubname" optionValue="hubid" placeholder="Select Hub"
                    formControlName="hubid" inputId="hubid" name="hubid"></p-dropdown>
                <span class="errormessage"
                    *ngIf="LocationForm.get('hubid').invalid  && (LocationForm.get('hubid').touched ||LocationForm.get('hubid').dirty)">
                    {{getErrorMessage(LocationForm,validation_message,'hubid')}}
                </span>
            </div>
            <div *ngIf="isRegionEnabled == 'Y'" class="field col-6"> 
                <label for="regionid" class="required-label">Region<span>*</span></label>   
                <p-dropdown [resetFilterOnHide]="true" [showClear]="true" [options]="regionList" [filter]="true"
                    appendTo="body" optionLabel="regionname" optionValue="regionid" placeholder="Select Region"
                    formControlName="regionid" inputId="regionid" name="regionid"></p-dropdown>
                <span class="errormessage"
                    *ngIf="LocationForm.get('regionid').invalid  && (LocationForm.get('regionid').touched || LocationForm.get('regionid').dirty)">
                    {{getErrorMessage(LocationForm,validation_message,'regionid')}}
                </span>
            </div>

        </div>

        <div class="formgrid grid">
            <div *ngIf="isCityEnabled == 'Y'" class="field col-6">
                <label for="cityid" class="required-label">City<span>*</span></label>   
                <p-dropdown [resetFilterOnHide]="true" [showClear]="true" [options]="cityList" [filter]="true"
                    appendTo="body" optionLabel="cityname" optionValue="cityid" placeholder="Select City"
                    formControlName="cityid" inputId="cityid" name="cityid"></p-dropdown>
                <span class="errormessage"
                    *ngIf="LocationForm.get('cityid').invalid  && (LocationForm.get('cityid').touched || LocationForm.get('cityid').dirty)">
                    {{getErrorMessage(LocationForm,validation_message,'cityid')}}
                </span>
            </div>
            <div *ngIf="locationTypeEnabled == 'Y'" class="field col-6">
                <label for="locationtypeid" class="required-label">{{locationTypeLabel}} Type<span>*</span></label>   
                <p-dropdown [resetFilterOnHide]="true" [showClear]="true" [options]="locationtype" [filter]="true"
                    appendTo="body" optionLabel="locationmodelname" optionValue="locationmodelid"
                    placeholder="Select location type" formControlName="locationtypeid" inputId="locationtypeid"
                    name="locationtypeid"></p-dropdown>
                <span class="errormessage"
                    *ngIf="LocationForm.get('locationtypeid').invalid  && (LocationForm.get('locationtypeid').touched || LocationForm.get('locationtypeid').dirty)">
                    {{getErrorMessage(LocationForm,validation_message,'locationtypeid')}}
                </span>
            </div>

        </div>
        <div class="formgrid grid">

            <div class="field col-6" *ngIf="isEdit">
                <label for="activeflag" class="required-label">Active Flag<span>*</span></label>    
                <p-dropdown [resetFilterOnHide]="true" [options]="activeFlag" inputId="activeflag" [filter]="true"
                    appendTo="body" name="activeflag" optionLabel="labelname" optionValue="value"
                    placeholder="Select Flag" formControlName="activeflag"></p-dropdown>
                <span class="errormessage"
                    *ngIf="LocationForm.get('activeflag').invalid  && (LocationForm.get('activeflag').touched || LocationForm.get('activeflag').dirty)">
                    {{getErrorMessage(LocationForm,validation_message,'activeflag')}}
                </span>
            </div>
        </div>
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="address" class="required-label">Address<span class="maxchars">(Max 500 chars)</span></label>
                <textarea [autoResize]="true" class="form-control" pInputTextarea formControlName="address"
                    inputId="address" id="address" name="address"></textarea>
                <span class="errormessage"
                    *ngIf="LocationForm.get('address').invalid  && (LocationForm.get('address').touched || LocationForm.get('address').dirty)">
                    {{getErrorMessage(LocationForm,validation_message,'address')}}
                </span>
            </div>
        </div>
    </form>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose"
            (click)="closemodal(LocationForm,this.ref,'Are you sure you want to close?')"></p-button>
        <p-button class="m-1" *ngIf="this.limitedAccess == 'N'" label="{{saveTitle}}" styleClass="customesave" (click)="addLocation()">
        </p-button>
    </div>
</div>